<template>
  <div class="box">
    <el-container style="height: 100%">
      <el-header
        style="font-size: 24px; background-color: #06f0bd; height: 60px"
      >
        <div>
          <div>浙江省烟草公司舟山市公司文明吸烟环境建设</div>
        </div>
      </el-header>
      <el-container>
        <!-- 导航栏菜单 -->
        <el-aside width="200px">
          <el-menu
            :default-active="activeIndex"
            class="el-menu-demo"
            mode="vertical"
            @select="handleSelect"
            background-color="#006953"
            text-color="#fff"
            active-text-color="#ffd04b"
            router
          >
            <el-menu-item route index="/home/amap">电子地图</el-menu-item>
            <el-menu-item index="/home/deviceContent">工单管理 </el-menu-item>
          </el-menu>
        </el-aside>
        <el-container>
          <el-main>
            <router-view></router-view>
          </el-main>
        </el-container>
      </el-container>
      <el-footer style="height: 40px; line-height: 40px"
        >浙江索宇智造建设科技有限公司</el-footer
      >
    </el-container>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  props: {},
  data() {
    return { activeIndex: "" };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    if (localStorage.getItem("url")) {
      this.activeIndex = localStorage.getItem("url");
    } else {
      this.activeIndex = "/home/amap";
    }
  },
  methods: {
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
      localStorage.setItem("url", keyPath);
    },
  },
};
</script>
<style scoped lang="less">
body,
html {
  height: 100%;
}
.box {
  width: 100%;
  height: 100%;
}

.el-header,
.el-footer {
  font-weight: 600;
  text-align: center;
  color: #333;
  line-height: 60px;
  background-color: rgba(#06f0bd, 0.5);
}

.el-aside {
  background-color: #006953;
  color: #333;
  text-align: center;
  line-height: 200px;
}

.el-main {
  background-color: #fff;
  color: #333;
  text-align: center;
  padding: 0;
}
.el-menu-item {
  width: 200px;
}
body > .el-container {
  width: 100%;
  height: 100%;
}

.el-container:nth-child(5) .el-aside,
.el-container:nth-child(6) .el-aside {
  line-height: 260px;
}

.el-container:nth-child(7) .el-aside {
  line-height: 320px;
}
</style>
